import logo from '../../assets/logo.svg';
import amex from '../../assets/credit-cards/amex.svg';
import diners from '../../assets/credit-cards/diners.svg';
import elo from '../../assets/credit-cards/elo.svg';
import hipercard from '../../assets/credit-cards/hipercard.svg';
import mastercard from '../../assets/credit-cards/mastercard.svg';
import visa from '../../assets/credit-cards/visa.svg';

import {
  StyledFooter,
  StyledLogo,
  StyledFooterContainer,
  StyledCreditCards,
  StyledCreditCardLogo
} from './style';

import Container from '../../components/container';

const Footer = () => {
  return(
    <StyledFooter>
      <Container>
        <StyledFooterContainer>
          <StyledLogo src={logo} alt="coffee&amp;joy" />

          <StyledCreditCards>
            <StyledCreditCardLogo src={visa} alt="Visa" />
            <StyledCreditCardLogo src={mastercard} alt="Mastercard" />
            <StyledCreditCardLogo src={elo} alt="Elo" />
            <StyledCreditCardLogo src={amex} alt="American Express" />
            <StyledCreditCardLogo src={hipercard} alt="Hipercard" />
            <StyledCreditCardLogo src={diners} alt="Diners Club" />
          </StyledCreditCards>
        </StyledFooterContainer>
      </Container>
    </StyledFooter>
  )
}

export default Footer
